import { reducerFromMap } from "../libs/helpers/reducers";
import { getDetailAndSchemaProps } from "../libs/helpers/callApi";

import {
  BRAND_DETAIL_LOADING,
  BRAND_DETAIL_LOADED,
  BRAND_DETAIL_LOAD_ERROR,
} from "../actions/brand.actions";

const reducer = {
  /*
   * BRAND_DETAIL
   */
  [BRAND_DETAIL_LOADING]: (state) => ({
    ...state,
    detail: {
      ...state.detail,
      loading: true,
    },
  }),
  [BRAND_DETAIL_LOADED]: (state, { data }) => ({
    ...state,
    detail: {
      loading: false,
      ...getDetailAndSchemaProps(data),
    },
  }),
  [BRAND_DETAIL_LOAD_ERROR]: (state, { data }) => ({
    ...state,
    detail: { loading: false },
    error: data,
  }),
};

export default reducerFromMap(reducer, { list: {} });
